import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { SearchContracts, SearchContractsVariables } from '@/graphql/contracts/_generated_/searchContract.query';
import SearchContractsQuery from '@/graphql/contracts/searchContract.query.gql';
import { notificationService } from '@/services/notification/notification.client';

export function useSearchContract() {
  const [_searchContract, { loading, data }] = useLazyQuery<SearchContracts, SearchContractsVariables>(
    SearchContractsQuery,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      })
    }
  );

  const searchContract = (contractNumber: string, count: number = 5) => {
    _searchContract({
      variables: {
        contractNumber,
        count
      }
    });
  };

  return {
    searchContract,
    searchResult: data?.searchContracts || [],
    isLoadingSearchContract: loading
  };
}
